module.exports = __webpack_public_path__ + "9aced80a3899c4d0757b285f93f59657.svg";